import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './hero4.css'

const Hero4 = (props) => {
  return (
    <div className="hero4-header13">
      <iframe
        src="https://quaaluderunner.web.app"
        allowFullScreen
        className="hero4-iframe1"
      ></iframe>
      <div className="hero4-content thq-section-padding">
        <div className="hero4-container thq-flex-column">
          <div className="hero4-max-width1 thq-flex-row thq-section-max-width thq-flex-column">
            <div className="hero4-column1">
              <h1 className="thq-heading-1 hero4-text1">
                {props.heading1 ?? (
                  <Fragment>
                    <span className="hero4-text5">
                      Welcome to our Cryptocurrency Services Platform
                    </span>
                  </Fragment>
                )}
              </h1>
            </div>
            <div className="hero4-column2">
              <p className="thq-body-large hero4-text2">
                {props.content1 ?? (
                  <Fragment>
                    <span className="hero4-text6">
                      Experience secure transactions and advanced blockchain
                      technology
                    </span>
                  </Fragment>
                )}
              </p>
              <div className="hero4-actions">
                <button className="thq-button-filled hero4-button1">
                  <span className="thq-body-small">
                    {props.action1 ?? (
                      <Fragment>
                        <span className="hero4-text7">Sign Up Now</span>
                      </Fragment>
                    )}
                  </span>
                </button>
                <button className="thq-button-outline hero4-button2">
                  <span className="thq-body-small">
                    {props.action2 ?? (
                      <Fragment>
                        <span className="hero4-text8">Learn More</span>
                      </Fragment>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="hero4-max-width2 thq-flex-row thq-section-max-width thq-flex-column">
            <div className="hero4-column3">
              <iframe
                src="https://quaaluderunner.web.app/leaderboard"
                allowFullScreen
                className="hero4-iframe2"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Hero4.defaultProps = {
  heading1: undefined,
  content1: undefined,
  action1: undefined,
  action2: undefined,
}

Hero4.propTypes = {
  heading1: PropTypes.element,
  content1: PropTypes.element,
  action1: PropTypes.element,
  action2: PropTypes.element,
}

export default Hero4
